import React from "react";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import FAQElement from "components/FAQ";

const FAQs = () => {
  const FAQdata = [
    {
      q: " How often is the Rated Afrika Playlist updated?",
      a: "The Rated Afrika Playlist is updated every week to ensure it features the freshest and most exciting tracks from across the continent. Our team curates the playlist carefully to include a mix of rising stars, chart-toppers, and hidden gems, keeping it vibrant and relevant for listeners."
    },
    {
      q: "How can I submit my music for the playlist?",
      a: "Submitting your music is easy! Simply create an account on the Rated Afrika platform, upload your track, and follow the submission guidelines provided. Our team will review your music, and if it fits our criteria, it will be added to the playlist."
    },
    {
      q: "What happens after my track is approved?",
      a: "Once your track is approved, it will be added to the Rated Afrika Playlist on platforms like Spotify, Apple Music, and YouTube Music. You’ll receive an email confirmation, and your track will start reaching our growing global audience."
    },
    {
      q: "What genres are added to our playlist?",
      a: "All genres of music are accepted on Rated Afrika’s playlist, ranging from; afrobeats, hip-hop, RnB Soul, Pop, Rap etc."
    }
  ];
  return (
    <Container>
      <Typography
        color={Colors.white300}
        size="3.6rem"
        weight="semibold"
        align="center"
        m_size="4xl"
      >
        Frequently asked questions
      </Typography>
      <Typography
        color={Colors.grey600}
        size="2xl"
        m_size="lg"
        mt="2"
        align="center"
      >
        Everything you need to know about Rated Afrika Playlist
      </Typography>
      <Items>
        {FAQdata.map(({ q, a }, i) => {
          return (
            <Item key={i}>
              <FAQElement q={q} a={a} />
            </Item>
          );
        })}
      </Items>
    </Container>
  );
};

export default FAQs;

const Container = styled.div`
  margin-top: 8rem;
  padding-bottom: 20rem;
  z-index: 100;
  position: relative;
`;

const Items = styled.div`
  margin-top: 6.8rem;
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-top: 3.2rem;
  }
`;
const Item = styled.div`
  margin-bottom: 3.2rem;
  width: 100%;
`;
